module.exports = __webpack_public_path__ + "img/icon-email.b7deb638.svg";